import { useRbTexts } from 'remote-state/applicationHooks';

export default function useTexts() {
  const texts = useRbTexts();
  const componentTexts = {
    getColumnText: (displayKey) => texts?.[displayKey],
  };

  return componentTexts;
}
